import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { ethCallRaw, isEvmAddress } from "./erc4626Rpc";

/** keccak256("decimals()")[:4] — ERC-20/ERC-4626 standard function selector */
const DECIMALS_SELECTOR = "0x313ce567";
async function fetchVaultDecimals(vaultAddress: string, chainId: number): Promise<number> {
  const raw = await ethCallRaw(vaultAddress, DECIMALS_SELECTOR, chainId);
  return Number(BigInt(raw));
}

/**
 * Hook that resolves the decimals of a vault (or token) contract.
 * Returns the decimals number or undefined while loading/on error.
 */
export function useErc4626Decimals(vaultAddress, chainId, t0) {
  const $ = _c(12);
  const enabled = t0 === undefined ? true : t0;
  let t1;
  let t2;
  if ($[0] !== chainId || $[1] !== vaultAddress) {
    t1 = ["erc4626-decimals", vaultAddress, chainId];
    t2 = () => fetchVaultDecimals(vaultAddress, chainId);
    $[0] = chainId;
    $[1] = vaultAddress;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== chainId || $[5] !== enabled || $[6] !== vaultAddress) {
    t3 = enabled && !!vaultAddress && !!chainId && isEvmAddress(vaultAddress);
    $[4] = chainId;
    $[5] = enabled;
    $[6] = vaultAddress;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = {
      queryKey: t1,
      queryFn: t2,
      enabled: t3,
      staleTime: Infinity,
      gcTime: 3600000,
      retry: 1
    };
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return useQuery(t4);
}